import axiosInstance from '../axiosInterceptor/axiosInstance'

const getApiKey = async (orgId) => {
  const url = `v1/orgs/${orgId}/api-key`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getApiKey
